module.exports = __webpack_public_path__ + "img/weilan-propa.c7c6ee6c.png";